export const environment = {
  production: true,
  elastic_url_search: '/wp-content/themes/pukeko-child/app/assets/api/elastic.php',
  elastic_url_doctyp27: '/wp-content/themes/pukeko-child/app/assets/api/elastic-doctyp27.php',
  elastic_url_doctyp28: '/wp-content/themes/pukeko-child/app/assets/api/elastic-doctyp28.php',
  elastic_url_analyse: '/wp-content/themes/pukeko-child/app/assets/api/elastic-analyse.php',
  elastic_url_lang: '/wp-content/themes/pukeko-child/app/assets/api/languageWP.php',
  elastic_url_json: '/wp-content/themes/pukeko-child/app/assets/json/'
};
